import defaultAvatarSrc from "./default-avatar.webp";

export const DEFAULT_AVATAR = defaultAvatarSrc;
